<template>
    <footer>
        <div class="footer-wrappper">
            <div class="footer-area footer-padding">
                <div class="container">
                    <div class="row justify-content-between">
                        <div class="col-xl-3 col-lg-5 col-md-4 col-sm-6">
                            <div class="single-footer-caption mb-50">
                                <div class="single-footer-caption mb-30">
                                    <!-- logo -->
                                    <div class="footer-logo mb-25">
                                        <router-link to="/"><img src="/images/logo/logo2_footer.png"
                                                alt=""></router-link>
                                    </div>
                                    <div v-if="textoLogo !=''" class="footer-tittle">
                                        <div class="footer-pera">
                                            <p v-html="textoLogo[0].itiResumo1"></p>
                                        </div>
                                    </div>
                                    <!-- social -->
                                    <div v-if="redes !=''" class="footer-social">
                                        <a :href="redes[0].itiNome" target="_blank"><i class="fab fa-facebook"></i></a>
                                        <a :href="redes[0].itiReferencia" target="_blank"><i
                                                class="fab fa-instagram"></i></a>
                                        <a :href="redes[0].itiCampoExtra2" target="_blank"><i
                                                class="fab fa-linkedin-in"></i></a>
                                        <a :href="redes[0].itiCampoExtra1" target="_blank"><i
                                                class="fab fa-youtube"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-5">
                            <div class="single-footer-caption mb-50">
                                <div class="footer-tittle">
                                    <h4>Menu</h4>
                                    <ul>
                                        <li><router-link to="/">Home</router-link></li>
                                        <li><router-link to="/sobre">Quem Somos</router-link></li>
                                        <li><router-link to="/blog">Notícias</router-link></li>
                                        <li><router-link to="/contato">Contato</router-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="listaProdutos.length > 0" class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div class="single-footer-caption mb-50">
                                <div class="footer-tittle">
                                    <h4>Produtos</h4>
                                    <ul>
                                        <li v-for="menu in listaProdutos" :key="menu.itiId">
                                            <router-link :to="'/ProdutosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome + menu.itiReferencia)">{{
                                            menu.itiNome }} {{ menu.itiReferencia }}</router-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6">
                            <div class="single-footer-caption mb-50">
                                <div class="footer-tittle">
                                    <h4>LGPD</h4>
                                    <ul class="mb-20">
                                        <li v-for="lgpd in informacoes" :key="lgpd.itiId">
                                            <router-link
                                                :to="'/informacoes/' + lgpd.itiId + '/' + lgpd.itiNome.replaceAll(' ', '-').replaceAll(',', '')">{{
                                                lgpd.itiNome }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- footer-bottom area -->
            <div class="footer-bottom-area">
                <div class="container">
                    <div class="footer-border">
                        <div class="row d-flex align-items-center">
                            <div class="col-xl-12" style="padding-bottom: 40px;">
                                <div class="footer-copy-right text-center ass-ava">
                                    <a href="https://avancedigital.com.br" target="_blank"
                                        rel="nofollow noopener">Desenvoldido por Avance Digital</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- END Footer -->



</template>

<script>
import axios from 'axios';

export default {
  name: 'PageFooter',
  components: {

  },
  data: () => ({
    redes: [],
    produtos: [],
    informacoes: [],
    textoLogo: [],
    listaProdutos: [],
  }),
  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
  },
  created() {
    //texto 
    axios.get('/Process/InsInstitucional/institucional/10/dadosrodape/0/x')
      .then(response => {
        this.textoLogo = response.data;
        //console.log('textoLogo')
        //console.log(this.textoLogo)
      })
      .catch(error => {
        console.error(error);
      });
    // redes sociais
    axios.get('/Process/InsInstitucional/institucional/55/redessociais/0/x')
      .then(response => {
        this.redes = response.data;
        //console.log('redes')
        //console.log(this.redes)
      })
      .catch(error => {
        console.error(error);
      });
    // produtos  
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        this.listaProdutos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('lista de produtos')
        //console.log(this.listaProdutos)
      })
      .catch(error => {
        console.error(error);
      });
    // redes informações
    axios.get('/Process/InsInstitucional/institucional/54/listadasinformacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>